import React from 'react';
import ContactUsComponent from '../ContactUs/ContactUsComponent';

export default function ContactUs() {

  return <section className="cx--section mt-5">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2 className="cx--section-title cx--section-dark-title">
            <span className="cx--primary-color">Have</span> questions? <br />
            Don't hesitate to <span className="cx--primary-color">reach out</span>.
          </h2>
        </div>
      </div>
      <ContactUsComponent />
    </div>
  </section>
}
